import gql from 'graphql-tag';

const GET_SHOP_SETTINGS = gql`
    query GetShopSettings($userId: ID!) {
        shop(id: $userId) {
            id
            userId
            active
            invitation {
                type
                value
            }
            static_file_eligible
            static_file_status
            static_file_mode
            review_clicked
            welcome_video_watched
            first_cart_turn_on
            first_new_campaign_click
            first_new_campaign
            scope
            transactions
            auto_upgrade
            current_plan
            multi_currency_checkout_alerted
            draft_checkout_alerted
            custom_links {
                selector
                action
            }
            custom_atcs {
                button
                id {
                    type
                    name
                    selector
                }
            }
            installedAt
            version
            money_format
            currency
            campaigns {
                id
            }
            settings {
                multiCurrencyMode
                default_language
                active
                open_cart
                rtl
                curved
                empty_cart
                custom_css
                theme {
                    textColor {
                        r
                        g
                        b
                        a
                    }
                    buttonColor {
                        r
                        g
                        b
                        a
                    }
                    primary {
                        r
                        g
                        b
                        a
                    }
                    secondary {
                        r
                        g
                        b
                        a
                    }
                    background {
                        r
                        g
                        b
                        a
                    }
                }
                font {
                    color {
                        r
                        g
                        b
                        a
                    }
                    size
                    family
                    custom
                }
                header {
                    title {
                        text
                        font_size
                        font_weight
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    background {
                        r
                        g
                        b
                        a
                    }
                }
                product {
                    title {
                        text
                        font_size
                        font_weight
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    price {
                        text
                        font_size
                        font_weight
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    image_size
                    grow
                    sold_out
                }
                product_details {
                    atcButton {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    atcButton_background {
                        r
                        g
                        b
                        a
                    }
                    atcButton_hoverBackground {
                        r
                        g
                        b
                        a
                    }
                    readMore {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    truncate
                    truncate_length
                    external
                }
                show_coupon
                show_coupon_alert_text
                is_checkout_condition_active
                checkout_condition_text
                active_continue_shopping_button
                active_continue_shopping_underlined
                continue_shopping_button {
                    text
                    font_size
                    font_weight
                    color {
                        r
                        g
                        b
                        a
                    }
                }
                checkout_condition_color {
                    r
                    g
                    b
                    a
                }
                modules {
                    order
                    random_text {
                        text
                        active
                    }
                    order_note {
                        text
                        active
                    }
                    checkout_button {
                        fix_checkout_container
                        active_continue_shopping_button
                        active_continue_shopping_underlined
                        continue_shopping_button {
                            text
                            font_size
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        button_text {
                            text
                            font_size
                            font_weight
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        button_text_loading {
                            text
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        background {
                            r
                            g
                            b
                            a
                        }
                        hoverBackground {
                            r
                            g
                            b
                            a
                        }
                        coupon {
                            background {
                                r
                                g
                                b
                                a
                            }
                            hoverBackground {
                                r
                                g
                                b
                                a
                            }
                            active_background {
                                r
                                g
                                b
                                a
                            }
                            active_color {
                                r
                                g
                                b
                                a
                            }
                        }
                        coupon_alert_text {
                            text
                            font_size
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        use_coupon_code {
                            text
                            font_size
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        enter_coupon_code {
                            text
                            font_size
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        apply_coupon_code {
                            text
                            font_size
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        edit_coupon_code {
                            text
                            font_size
                        }
                        close_coupon_code {
                            text
                            font_size
                        }
                        subtotal {
                            text
                            font_size
                            font_weight
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                        savings {
                            text
                            font_size
                            font_weight
                            color {
                                r
                                g
                                b
                                a
                            }
                        }
                    }
                }
                cod_settings {
                    is_active
                    is_form_in_cart
                    error_message
                    checkout_mode
                    checkout_button {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                        background {
                            r
                            g
                            b
                            a
                        }
                        hoverBackground {
                            r
                            g
                            b
                            a
                        }
                    }
                    confirm_button {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                        background {
                            r
                            g
                            b
                            a
                        }
                        hoverBackground {
                            r
                            g
                            b
                            a
                        }
                    }
                    loading_button {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                        background {
                            r
                            g
                            b
                            a
                        }
                        hoverBackground {
                            r
                            g
                            b
                            a
                        }
                    }
                    form {
                        label
                        placeholder
                        isRequired
                        type
                        options
                    }
                }
                sticky_cart {
                    isActive
                    btn_style
                    btn_text
                    btn_text_unavailable
                    btn_text_variant_active
                    btn_color {
                        r
                        g
                        b
                        a
                    }
                    txt_color {
                        r
                        g
                        b
                        a
                    }
                    background_color {
                        r
                        g
                        b
                        a
                    }
                    atc_action
                    desktop_active
                    desktop_show_quantity
                    desktop_show_variants
                    desktop_product_preview
                    desktop_show_product_name
                    desktop_show_compared_price
                    desktop_visibility
                    desktop_location
                    desktop_quantity {
                        text
                    }
                    mobile_quantity {
                        text
                    }
                    cart_name {
                        text
                    }
                    mobile_active
                    mobile_show_variants
                    mobile_show_quantity
                    mobile_show_compared_price
                    mobile_visibility
                    mobile_location
                    mobile_show_title
                    mobile_show_price
                    mobile_atc_height {
                        font_size
                        text
                    }
                    show_btn_atc_txt_variant_active
                    btn_atc_txt_variant_active
                }
                badges {
                    isActive
                    position
                    value
                }
                auto_discount {
                    text {
                        text
                        font_size
                        font_weight
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    background {
                        r
                        g
                        b
                        a
                    }
                    border {
                        r
                        g
                        b
                        a
                    }
                }
                scary {
                    isActive
                    text {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    style
                    background {
                        r
                        g
                        b
                        a
                    }
                    border {
                        r
                        g
                        b
                        a
                    }
                    isDaysActive
                    isHoursActive
                    isMinutesActive
                    isSecondsActive
                    days
                    hours
                    minutes
                    seconds
                    endAction
                    placement
                    textAlignement
                }
                afterPay {
                    isActive
                    splits
                    image
                    isExternal
                    text {
                        text
                        font_size
                        font_weight
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                }
                announcement {
                    isActive
                    text {
                        text
                        font_size
                        color {
                            r
                            g
                            b
                            a
                        }
                    }
                    style
                    background {
                        r
                        g
                        b
                        a
                    }
                    border {
                        r
                        g
                        b
                        a
                    }
                    position
                    textAlignement
                }
                count_compare_at
            }
            chargeCreated
            chargeConfirmationUrl
            chargeAccepted
            snippetCreated
            enabled_presentment_currencies
        }
    }
`;

export default GET_SHOP_SETTINGS;
